import { render, staticRenderFns } from "./ReferringDomains.vue?vue&type=template&id=63143083&scoped=true&"
import script from "./ReferringDomains.vue?vue&type=script&lang=js&"
export * from "./ReferringDomains.vue?vue&type=script&lang=js&"
import style0 from "./ReferringDomains.vue?vue&type=style&index=0&id=63143083&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63143083",
  null
  
)

/* custom blocks */
import block0 from "./ReferringDomains.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports